import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { AnnotationService } from '../../service/annotation.service';
import { ToastService } from '../../service/toast.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { SearchService } from '../../service/search.service';
import { FinderData, AdminSearch } from '../../model/search';
import { Tchekb } from '../../model/tchekb.model';
import { Subscription } from 'rxjs';
import { Damage } from '../../model/damage.model';
import { ClassificationService } from '../../service/classification.service';
import { LocalstorageService } from '../../service/localstorage.service';
import { NgbModalRef, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-classification',
  templateUrl: './classification.component.html',
  styleUrls: ['./classification.component.less']
})
export class ClassificationComponent implements OnInit {

  listTcheks: Tchekb[];
  finderData: FinderData;
  classSearch: string[]
  isRunning: boolean;
  damageSelected: Damage;
  subscription: Subscription;
  @ViewChild('content') content: ElementRef;

  closeResult: string;
  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private _annotationService: AnnotationService,
    private readonly _toastService: ToastService,
    private readonly _router: Router,
    private _route: ActivatedRoute,
    private readonly _searchService: SearchService,
    private readonly _classificationService: ClassificationService,
    private _localStorageService: LocalstorageService) {
    this.listTcheks = this._searchService.TchekList;

    this.isRunning = false;
    this.classSearch = []
    this.finderData = this._searchService.finderData
    this.openPlayer(this._classificationService.active)

    this._route.params.subscribe((params: Params) => {
      // console.log('Route rcv new params', params);
      if (params['id']) {
        let camName = params['camName'];
        let tchekId = params['id'];
        let routerNumberPic = params['picNum'] ? Number(params['picNum']) : 0;
        let videoNumber = params['picNum'] ? Number(params['picNum']) : 0;
        this.openPlayer(true)
        this._router.navigate(['/player', tchekId, camName, routerNumberPic]);
      }

    });
  }


  ngOnInit() {
  }


  openmodal() {
    this.finderData.admin.searchTags = []
    this.finderData.admin.damageSearch = false;
    this.finderData.admin.searchTagList.damageTag.forEach(element => {
      element.checked = false;
    });

    this.modalRef = this.modalService.open(this.content, { backdropClass: 'backdropClassModal' });
    this.modalRef.result.then((result) => {
      this.finderData.admin.damageSearch = true;
      this._classificationService.active = true
      this._localStorageService.setItem('classification', JSON.stringify({ active: true }));
      this.openPlayer(true)
    }, (reason) => {
      this._classificationService.active = false
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openPlayer(e) {
    console.log("classification openPlayer", this.finderData);
    this.listTcheks = this._searchService.TchekList;
    if (e === true) {
      this.isRunning = true
    } else if (e === 'erase') {
      console.log("classification clear finder");
      this.finderData.admin.searchTags = []
      this.finderData.admin.damageSearch = false;
      this.finderData.admin.searchTagList.damageTag.forEach(element => {
        element.checked = false;
      });
      this.isRunning = false
    }
    this._classificationService.setlistTags()
    this._classificationService.setClassification(this.isRunning)
    this._localStorageService.setItem('classification', JSON.stringify({ active: this.isRunning }));
  }

  oneTagIsTrue(): boolean {
    return !this.finderData.admin.searchTagList.damageTag.every((tag) => { return tag.checked === false })
  }

}



// WEBPACK FOOTER //
// ./src/app/element/classification/classification.component.ts